<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import Select from './Select.vue';
import { computedAsync } from '@vueuse/core';
import adminAPI from '@/services/api';

const props = defineProps<{ claimId: string }>();
const emit = defineEmits(['update:modelValue']);

// const courts = ref(await adminAPI.listCompetentCourtsForClaim(props.claimId));
const courts = ref(await adminAPI.listCompetentCourtsForClaim(props.claimId));
watch(() => props.claimId, async () => {
  courts.value = await adminAPI.listCompetentCourtsForClaim(props.claimId)
  const allOptions = courtsToOptions();
  emit('update:modelValue', allOptions[0])
});

/** Suggest competent courts first, but list all courts then, for flexibility */
function courtsToOptions() {
  const data = [
    { label: "Aucun choix sélectionné", value: null as any },
    { label: (courts.value?.airline?.name || "Aucun") + " (Siège compagnie)", value: courts.value?.airline?.id as any },
    { label: (courts.value?.departureAirport?.name || "Aucun") + " (Lieu Départ)", value: courts.value?.departureAirport?.id as any },
    { label: (courts.value?.arrivalAirport?.name || "Aucun") + " (Lieu d'Arrivée)", value: courts.value?.arrivalAirport?.id as any },
  ]
  if (courts.value?.all) {
    return data.concat(
      ...courts.value.all.map((c) => ({ label: c.name, value: c.id }))
    )
  }
  return data;
}

const options = computed<Array<{ value: number; label: string; }>>(() => courtsToOptions());
const selected = ref(courts[0]);
const selectedOptionIndex = ref(0);
</script>
<template>
  <div class="text-left cursor-pointer">
    <Select @update:modelValue="(value) => $emit('update:modelValue', value as any)"
      label="Tribunal compétent"
      :options="options"
      :selected-option="selectedOptionIndex"
    />
  </div>
</template>